import { useQuery } from 'react-query';

import { UsageActivityBreakdownResponseDto } from '../../../../../backend/src/usage/dto/usage-activity-breakdown.response.dto';
import { UsageStatsRequestDto } from '../../../../../backend/src/usage/dto/usage-stats.request.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

type ActivityBreakdownFilters = Pick<UsageStatsRequestDto, 'organisationId' | 'startDate' | 'endDate'>;

// Activity leaderboards (users and matters ranked by Kim threads) for the activity dashboard.
export const useGetOrgActivityBreakdown = ({
  data,
  enabled = true,
}: {
  data: ActivityBreakdownFilters;
  enabled?: boolean;
}) => {
  const { getFetchConfig } = useGetFetchConfig();

  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data,
  });

  return useQuery<UsageActivityBreakdownResponseDto>(
    [QueryEntity.UsageActivityBreakdown, data.organisationId, data.startDate, data.endDate],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/usage/activity-breakdown`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new Error('Network response was not ok from getOrgActivityBreakdown');
      return response.json();
    },
    { enabled, refetchOnWindowFocus: false },
  );
};
